import apiClient from './axios';

export const requestSubscriptionEdit = (payload) => {
    return apiClient.post('/subscriber/request-edit',  payload );
};

export const verifySubscriptionEdit = (payload) => {
    return apiClient.post('/subscriber/verify-edit',  payload );
};


export const deleteSubscription = () => {
    return apiClient.post('/subscriber/delete');
};


export const getCurrentUser = () => {

    return apiClient.get('/subscriber/me');
}
